import { useState, useEffect } from 'react';

function useGetSendersByCountry(organizationId, timeRange = '7d') {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!organizationId) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `/api/v1/organizations/${organizationId}/analytics/senders_by_country?time_range=${timeRange}`
        );

        if (!response.ok) throw new Error('Failed to fetch sender countries');

        const result = await response.json();
        setData(result);
        setError(null);
      } catch (err) {
        setError(err.message);
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [organizationId, timeRange]);

  return { data, loading, error };
}

export default useGetSendersByCountry;
